import { useQuery } from '@tanstack/react-query';
import { apiServiceProxy } from 'v2/services/api-proxy';

export function useRegistryCheckModal(enabled: boolean) {
  return useQuery({
    queryKey: ['registry-check-modal'],
    queryFn: () => apiServiceProxy.post<boolean>('/registry/check-modal', {}).then(response => response.data),
    enabled
  });
}
